<div class="build-info-page">
  <div class="build-info-card">
    <p class="build-info-eyebrow">Diagnostica build</p>
    <h1>Build info</h1>
    <p class="build-info-intro">
      Pagina non linkata, utile per verificare rapidamente se il browser sta caricando la build attesa o asset cacheati.
    </p>

    <dl class="build-info-summary">
      <div>
        <dt>App version</dt>
        <dd>{{ appVersion }}</dd>
      </div>
      <div>
        <dt>Angular</dt>
        <dd>{{ angularVersion }}</dd>
      </div>
      <div>
        <dt>Environment</dt>
        <dd>{{ environmentName }}</dd>
      </div>
      <div>
        <dt>Opened at</dt>
        <dd>{{ openedAt }}</dd>
      </div>
      <div>
        <dt>Current URL</dt>
        <dd class="build-info-break">{{ currentUrl }}</dd>
      </div>
    </dl>

    <section class="build-info-assets">
      <h2>Loaded assets</h2>
      <p>
        In produzione il dato più utile è il nome dei bundle caricati: se cambia l'hash del file, stai guardando una build diversa.
      </p>

      <table>
        <thead>
          <tr>
            <th>Tipo</th>
            <th>File</th>
            <th>URL</th>
          </tr>
        </thead>
        <tbody>
          @for (asset of loadedAssets; track asset.fullUrl) {
            <tr>
              <td>{{ asset.kind }}</td>
              <td>{{ asset.fileName }}</td>
              <td class="build-info-break">{{ asset.fullUrl }}</td>
            </tr>
          }
        </tbody>
      </table>
    </section>
  </div>
</div>